var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.96 116.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 29") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,27.14c6.75,0,12-7,11.74-15.39C67,3.37,63.35-.26,55,0,46.6-.26,43,3.37,43.25,11.75,43,20.12,48.23,27.14,55,27.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,54.43H74a2.66,2.66,0,0,0,2.65-2.66V34.27A3.49,3.49,0,0,0,74,31l-6.42-1.48a3.76,3.76,0,0,0-3.88,1.74l-7.48,13.6c-.71,1.28-1.86,1.28-2.56,0l-7.49-13.6a3.75,3.75,0,0,0-3.87-1.74L35.91,31a3.49,3.49,0,0,0-2.59,3.25v17.5A2.67,2.67,0,0,0,36,54.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18,100.19c4.1,0,7.31-4.28,7.14-9.37.17-5.1-2-7.31-7.14-7.14-5.09-.17-7.3,2-7.14,7.14C5.88,95.91,9.08,100.19,13.18,100.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.78,102.55l-3.91-.9a2.26,2.26,0,0,0-2.35,1.06L14,111c-.43.77-1.13.77-1.56,0l-4.56-8.28a2.26,2.26,0,0,0-2.35-1.06l-3.91.9a2.12,2.12,0,0,0-1.58,2v10.68a1.62,1.62,0,0,0,1.62,1.62H24.74a1.61,1.61,0,0,0,1.62-1.62V104.53A2.12,2.12,0,0,0,24.78,102.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.84,90.82c-.17,5.09,3,9.37,7.14,9.37s7.31-4.28,7.14-9.37c.17-5.1-2-7.31-7.14-7.14C49.88,83.51,47.67,85.72,47.84,90.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.58,102.55l-3.91-.9a2.28,2.28,0,0,0-2.36,1.06L55.76,111c-.43.77-1.13.77-1.56,0l-4.56-8.28a2.28,2.28,0,0,0-2.36-1.06l-3.91.9a2.13,2.13,0,0,0-1.57,2v10.68a1.62,1.62,0,0,0,1.61,1.62H66.54a1.62,1.62,0,0,0,1.62-1.62V104.53A2.12,2.12,0,0,0,66.58,102.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.63,90.82c-.16,5.09,3,9.37,7.14,9.37s7.31-4.28,7.15-9.37c.16-5.1-2-7.31-7.15-7.14C91.68,83.51,89.47,85.72,89.63,90.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,102.55l-3.91-.9a2.28,2.28,0,0,0-2.36,1.06L97.56,111c-.44.77-1.14.77-1.57,0l-4.55-8.28a2.28,2.28,0,0,0-2.36-1.06l-3.91.9a2.12,2.12,0,0,0-1.58,2v10.68a1.62,1.62,0,0,0,1.62,1.62h23.13a1.62,1.62,0,0,0,1.62-1.62V104.53A2.12,2.12,0,0,0,108.38,102.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.84 79.04 93.84 72.02 57.81 72.02 57.81 79.04 52.15 79.04 52.15 72.02 16.11 72.02 16.11 79.04 10.45 79.04 10.45 66.35 52.15 66.35 52.15 59.31 57.81 59.31 57.81 66.35 99.51 66.35 99.51 79.04 93.84 79.04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.14db89cae9d2bb585b1bdc6f70d89634.svg";
export { ForwardRef as ReactComponent };